import FormRowDecimalInput from 'components/FormRowDecimalInput/FormRowDecimalInput';

export default FormRowDecimalInput;
